// extracted by mini-css-extract-plugin
module.exports = {"appIcon":"AppModal-module-app-icon","text":"AppModal-module-text","marketplaceLinks":"AppModal-module-marketplace-links"};